import {InitPage} from "../index";
import swal from "sweetalert";

class DeleteDialog {
    constructor() {
        const _this = this;
        $(".deleteRecordDialog").on("click", function(){
            let deleteMessage = "This operation will delete the row logically";
            let deleteTitle   = "Are you sure?";
            const _anchor = this;
            if (typeof $(_anchor).data("delete-message") !== "undefined") {
                deleteMessage = $(_anchor).data("delete-message");
            }
            if (typeof $(_anchor).data("delete-title") !== "undefined") {
                deleteTitle = $(_anchor).data("delete-title");
            }
            _this.confirm_delete($(_anchor).data("delete-path"), deleteTitle, deleteMessage);
        });

        $('.deleteRecord').on('click',function(e){
          var message = $(this).attr('data-delete-message');
                  swal({
                    title: 'Are you sure?',
                    text:  message,
                    icon: "warning",
                    closeOnClickOutside: false,
                    buttons: {
                      cancel: {
                        text: "No",
                        value: null,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-silver",
                        closeModal: true
                      },
                      confirm: {
                        text: "Yes",
                        value: true,
                        visible: true,
                        className: "sn-btn sn-btn-sm sn-btn-red",
                        closeModal: true
                      }
                    },
                    dangerMode: true,
                  }).then((willDelete) => {
                    if (willDelete) {
                      var target = $(e.currentTarget).next();
                      target.click();              
                    } else {
                      return false;
                    }
                  });
              });
    }

    confirm_delete(deletePath, deleteTitle, deleteMessage) {
        swal({
          title: deleteTitle,
          text:  deleteMessage,
          icon: "warning",
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: "No",
              value: null,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-silver",
              closeModal: true
            },
            confirm: {
              text: "Yes",
              value: true,
              visible: true,
              className: "sn-btn sn-btn-sm sn-btn-red",
              closeModal: true
            }
          },
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            $.ajax({
              type: "DELETE",
              url: deletePath
            });
          } else {
            return false;
          }
        });
      }

}

export function LoadPage() {
    const delete_dialog = new DeleteDialog();
}

